var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: "/icon.png",
      alt: ""
    }
  }), _c("div", [_vm._v("AI渔业平台小助手")])]), _c("div", {
    staticClass: "list"
  }, [_c("div", {
    staticClass: "you dialog-box",
    staticStyle: {
      padding: "12px 16px"
    }
  }, [_vm._v("你好！欢迎来到“AI渔业平台小助手”，这里有你的问题和答案。无论你在寻找知识、解答疑惑还是寻求建议，我都会尽力帮助你。请告诉我你的问题，我会尽力为你提供最佳答案。")]), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "you dialog-box"
    }, [item.you ? _c("div", {
      staticStyle: {
        padding: "12px 16px"
      }
    }, [_vm._v(_vm._s(item.content))]) : _vm._e()]), _c("div", {
      staticClass: "me dialog-box"
    }, [item.me ? _c("div", {
      staticStyle: {
        padding: "12px 16px"
      }
    }, [_vm._v(_vm._s(item.content))]) : _vm._e()])]);
  })], 2), _c("div", {
    staticClass: "input-container"
  }, [_c("el-tooltip", {
    attrs: {
      content: "清空历史会话",
      placement: "top",
      effect: "light"
    }
  }, [_c("i", {
    staticClass: "el-icon-delete",
    staticStyle: {
      color: "#b8babf"
    },
    on: {
      click: _vm.deleteClick
    }
  })]), _c("div", {
    staticClass: "input"
  }, [_c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.problem,
      expression: "problem"
    }],
    attrs: {
      placeholder: "请开始提问",
      maxlength: "2000",
      rows: "1"
    },
    domProps: {
      value: _vm.problem
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.submitClick.apply(null, arguments);
      },
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.problem = $event.target.value;
      }
    }
  }), _c("img", {
    attrs: {
      src: "https://agi-dev-platform-web.cdn.bcebos.com/ai_apaas/dist/img/sendIcon_bc38d110.png",
      alt: ""
    },
    on: {
      click: _vm.submitClick
    }
  })])], 1)])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };